<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <form @submit.prevent="submit">
      <div class="modal-card">
        <header class="modal-card-head">
          <h1 class="is-title-header modal-card-title">
            {{ action }}
          </h1>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <b-field label="Entity Name">
                <b-input
                  name="name"
                  maxlength="200"
                  v-model="editObjectName.name"
                  required
                  :disabled="isAdd"
                />
              </b-field>
              <b-field label="CRM ID" v-if="!isExternal">
                <b-input
                  name="crm_id"
                  maxlength="200"
                  v-model="editObjectName.crm_id"
                  :disabled="isAdd"
                  placeholder="Unique ID"
                />
              </b-field>

              <b-field label="Address">
                <b-input
                  name="address"
                  maxlength="200"
                  type="textarea"
                  v-model="editObjectName.address"
                  required
                  :disabled="isAdd"
                />
              </b-field>

              <b-field label="Country">
                <b-select
                  name="entity_country"
                  :disabled="isAdd"
                  v-model="editObjectName.entity_country_id"
                  required
                  expanded
                  placeholder="Please select"
                >
                  <option
                    v-for="(option, index) in countries"
                    :value="option.id"
                    :key="index"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" v-if="!isAdd">
          <b-button slot="right" type="is-primary" native-type="submit">
            Add
          </b-button>
          <b-button slot="right" type="is-danger" @click="cancel">
            Cancel
          </b-button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
import CountryDataService from "../../services/CountryDataService";
import utilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
// @group Customers
export default {
  name: "CustomerEntityAddView",
  mixins: [UserPermissionMixin, utilityMixin, ScopeMixin],
  props: {
    action: {
      type: String,
      default: "Inserts"
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    editObjectName: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  data() {
    return {
      isModalActive: false,
      countryDataService: new CountryDataService(),
      countries: [],
      isExternal: false
    };
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null || this.userExternalCheck()) {
      this.isExternal = true;
    }
    this.fetchCountries();
  },
  computed: {
    countryList() {
      return this.$store.state.countryList;
    }
  },
  methods: {
    fetchCountries() {
      if (this.countryList.length > 0) {
        this.countries = this.countryList;
      } else {
        this.countryDataService.getAll().subscribe(
          response => {
            this.countries = response;
            this.$store.dispatch("setCountryList", response);
          },
          e => {
            console.log(e);
          }
        );
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    submit() {
      this.$emit("confirm", this.editObjectName);
    }
  },

  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
